module.exports = __webpack_public_path__ + "img/img_element_four.a26a8433.svg";